import React, { FunctionComponent, useState, useEffect } from "react"
import { apiHelper } from "../apiHelper"
import { FullSoccerFieldResponse, SoccerField, Place } from "../types"
import {
    Card,
    CardContent,
    Typography,
    Skeleton,
    IconButton,
    Link,
} from "@mui/material"
import LinkIcon from '@mui/icons-material/Link';
import LaunchIcon from '@mui/icons-material/Launch';
import { CopyToClipboardTooltip } from "./CopyToClipboardTooltip"
import { useTranslation } from "next-i18next"
import { FieldSurfaceSizes } from "./FieldSurfaceSizes";
import { FieldSurfaceType } from "./FieldSurfaceType";

export const FieldDetailsMiniLoader: FunctionComponent<{
    shortId: string
}> = ({
    shortId,
}) => {
        const [data, setData] = useState<FullSoccerFieldResponse | null>(null)

        useEffect(() => {
            async function load() {
                const loadedField: FullSoccerFieldResponse = await apiHelper.get(
                    `/api/fields/f/${shortId}`
                );
                setData(loadedField)
            }
            load()

        }, [])

        return (data ? (<FieldDetailsMini
            field={data.soccerField}
            place={data.place}
        ></FieldDetailsMini>) : (
            <Skeleton variant="rectangular" height={118} />
        ))
    }

export const FieldDetailsMini: FunctionComponent<{
    field: SoccerField
    place?: Place
}> = ({
    field,
    place,

}) => {
        const { t } = useTranslation();
        return <Card>
            <CardContent>
                <Typography variant="h3">
                    {field.name}
                    <CopyToClipboardTooltip
                        title={t('copyLinkTooltip.title', { ns: 'common' })}
                        copiedTitle={t('copyLinkTooltip.copiedTitle', { ns: 'common' })}
                    >
                        <IconButton aria-label="share">
                            <LinkIcon />
                        </IconButton>
                    </CopyToClipboardTooltip>
                </Typography>
                {place &&
                    <>
                        <Link
                            color="secondary"
                            style={{ cursor: 'pointer' }}
                            href={""}
                            target="_blank"
                        >
                            {place.name}
                            <LaunchIcon fontSize="small" />
                        </Link>
                        {/* {soccerFieldResponse?.city.name}, {soccerFieldResponse.state.name}, {soccerFieldResponse.country.name} */}
                    </>
                }
                <br />
                <FieldSurfaceSizes sizes={field.sizes} />
                <FieldSurfaceType type={field.type} />
            </CardContent>
        </Card>
    }